"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { usePathname } from "@opensea/navigation";
import { useTranslations } from "next-intl";
import { useDropStore } from "./drops/components/CollectionDropContext";
import { DropStatus } from "./drops/constants";
import { useCollectionTabsFragment } from "./use-collection-tabs.fragment";
import { getCollectionUrlBySlug } from "./utils";
const HEADER_VIEW_REGEX = /\/(?<headerView>full|compact)(?![\w-])/;
export const useCollectionTabs = collectionKey => {
  const collection = readFragment(useCollectionTabsFragment, collectionKey);
  const baseCollectionUrl = getCollectionUrlBySlug(collection?.slug ?? "");
  const status = useDropStore(state => collectionKey ? state.status : null);
  const highlightMint = status === DropStatus.MINTING || status === DropStatus.MINTING_SOON;
  const t = useTranslations("useCollectionTabs");
  const showOffersTab = collection?.flags.isOffersEnabled;
  const showOverviewTab = Boolean(collection?.overview?.modules?.length) || Boolean(collection?.drop && collection.drop.type !== "SEADROP_V2_ERC1155_SELF_MINT");
  const showTokensTab = Boolean(collection?.currencies.length);
  const showExploreTab = collection?.previewItems?.length && !collection.previewItems[0].isFungible && collection.previewItems[0].rarity && collection.stats.uniqueItemCount && collection.stats.uniqueItemCount >= 50;
  const showTraitsTab = collection?.flags.supportsAttributesBySlug;
  const tabs = [showExploreTab && {
    id: "explore",
    title: t("explore"),
    href: `${baseCollectionUrl}/explore`
  }, {
    id: "items",
    title: t("items"),
    href: baseCollectionUrl
  }, showTokensTab && {
    id: "tokens",
    title: t("tokens"),
    href: `${baseCollectionUrl}/tokens`
  }, showOffersTab && {
    id: "offers",
    title: t("offers"),
    href: `${baseCollectionUrl}/offers`
  }, {
    id: "holders",
    title: t("holders"),
    href: `${baseCollectionUrl}/holders`
  }, showTraitsTab && {
    id: "traits",
    title: t("traits"),
    href: `${baseCollectionUrl}/traits`
  }, {
    id: "activity",
    title: t("activity"),
    href: `${baseCollectionUrl}/activity`
  }].flatMap(tab => tab ? [tab] : []);
  if (showOverviewTab) {
    const aboutTab = {
      id: "overview",
      title: highlightMint ? t("mint") : t("about"),
      href: `${baseCollectionUrl}/overview`
    };
    if (highlightMint) {
      tabs.unshift(aboutTab);
    } else {
      tabs.push(aboutTab);
    }
  }
  return tabs;
};
const isItemActive = (collectionSlug, pathname, item) => {
  // Vercel bug causes pathname here to be the rewritten pathname from middleware only on Vercel
  const pathnameWithoutRewrites = pathname.replace(HEADER_VIEW_REGEX, "");
  if (item.href === getCollectionUrlBySlug(collectionSlug)) {
    if (pathnameWithoutRewrites.startsWith(`${getCollectionUrlBySlug(collectionSlug)}/items`)) {
      return true;
    }

    // Remove query params
    return item.href.split("?")[0] === pathnameWithoutRewrites;
  }

  // Remove query params
  return pathnameWithoutRewrites.startsWith(item.href.split("?")[0]);
};
export const useIsItemActive = collectionSlug => {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  if ($[0] !== collectionSlug || $[1] !== pathname) {
    t0 = item => isItemActive(collectionSlug, pathname, item);
    $[0] = collectionSlug;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};